module.exports = __webpack_public_path__ + "static/media/singer-girl2.59547f28.png";